import React, { useEffect, useState, useCallback } from "react";

import { FormattedMessage } from "react-intl";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import MergedUserTable from "./MergedUserTable"
import Summary from "./Summary";
import SectionDetailsLink from "../common/SectionDetailsLink";
import SimpleModalCompact from "../../../common/ModalCompact/SimpleModalCompact";
import { SUBSCRIPTION_LEVEL } from "../../../../constant/subscriptionLevel";


function createDetailsRow(username, isExternalUser, subscriptionLevel) {
  return { username, isExternalUser, subscriptionLevel };
}


function createSummaryRow(subscriptionLevel, quantity) {
  return { subscriptionLevel, quantity };
}

const subscriptionLevelOrder = [
  SUBSCRIPTION_LEVEL.Premium,
  SUBSCRIPTION_LEVEL.Pro,
  SUBSCRIPTION_LEVEL.Business,
  SUBSCRIPTION_LEVEL.Standard,
  SUBSCRIPTION_LEVEL.Mini,
  SUBSCRIPTION_LEVEL.Free,
  SUBSCRIPTION_LEVEL.Unknown,
];

const sortUsers = (usersArray = []) =>
  [...usersArray].sort((a, b) => {
    const levelComparison =
      subscriptionLevelOrder.indexOf(a.subscriptionLevel) -
      subscriptionLevelOrder.indexOf(b.subscriptionLevel);
    if (levelComparison !== 0) return -levelComparison; // descending
    return a.username.localeCompare(b.username); // then by username
  });

const sortSummaryRows = (rows = []) =>
  [...rows].sort((a, b) => {
    const levelComparison =
      subscriptionLevelOrder.indexOf(a.subscriptionLevel) -
      subscriptionLevelOrder.indexOf(b.subscriptionLevel);
    return -levelComparison; // descending
  });

const SubscriptionLevelsSection = ({ classes, users }) => {
  const [openDetails, setOpenDetails] = useState(false);


  const toggleOpenDetails = () => {
    setOpenDetails(!openDetails);
  };


  const summaryRows = useCallback(() => {
    const allUsers = [...(users.ownUsers || []), ...(users.paymentLiableUsers || [])];
    const counts = allUsers.reduce((acc, user) => {
      const level = user.subscriptionLevel || SUBSCRIPTION_LEVEL.Unknown;
      acc[level] = (acc[level] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(counts).map(([subscriptionLevel, quantity]) =>
      createSummaryRow(subscriptionLevel, quantity)
    );
  }, [users]);

  return (
    <>
      <Typography className={classes.sectionTitle}>
        <FormattedMessage id="admin.subscriptions.subscriptionLevels.title" />
      </Typography>
      <Grid container item xs={12} md={4}>
        <Summary className={classes.sectionSummary} rows={sortSummaryRows(summaryRows())} />
      </Grid>
      <SectionDetailsLink
        className={classes.sectionDetailsLink}
        onClick={toggleOpenDetails}
      />


      <SimpleModalCompact
        open={openDetails}
        title="Merged Users"
        onClose={toggleOpenDetails}
      >
        <MergedUserTable
          ownUsers={sortUsers(users.ownUsers)}          
          paymentLiableUsers={sortUsers(users.paymentLiableUsers)}
          historicData={users.historicData}
        />
      </SimpleModalCompact>
    </>
  );
};

SubscriptionLevelsSection.defaultProps = {
  classes: {},
};

SubscriptionLevelsSection.propTypes = {
  classes: PropTypes.object,
};

export default SubscriptionLevelsSection;
